export default "__VITE_ASSET__oxlEWnxy__"